import React, { useState } from "react";

import { useNavigate } from "react-router-dom";

import "../App.css";

function OTPVerification() {

  const navigate = useNavigate();

  const [otp, setOtp] = useState("");

const verifyOTP = () => {

  if (otp === "1234") {

    alert("OTP Verified");

    navigate("/login");

  } else {

    alert("Invalid OTP");

  }

};

  return (

    <div className="center-screen">

      <div className="login-box">

        <h1>OTP Verification</h1>

        <input
          type="text"
          placeholder="Enter OTP"
          value={otp}
          onChange={(e) => setOtp(e.target.value)}
        />

        <button onClick={verifyOTP}>
          Verify OTP
        </button>

        <button>
          Resend OTP
        </button>

        <p>
          Demo OTP: 1234
        </p>

      </div>

    </div>
  );
}

export default OTPVerification;